module.exports = __webpack_public_path__ + "img/image.b106525c.svg";